import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AtoProcessual } from '@app/models/ato-processual.model';
import { AtoProcessualService } from '@app/services/ato-processual.service';

@Component({
  selector: 'app-ato-processual-form',
  templateUrl: './ato-processual-form.component.html'
})
export class AtoProcessualFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  atoProcessual: AtoProcessual = new AtoProcessual();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private atoProcessualService: AtoProcessualService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Ato Processual' : 'Novo Ato Processual';

      if (!id) {
        return;
      }

      this.atoProcessualService.obterPorId(id).toPromise().then(
        data => this.atoProcessual = data,
        () => this.router.navigate(['./configuracoes/ato-processual']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.atoProcessualService.gravar(this.atoProcessual).toPromise().then(
      () => this.router.navigate(['./configuracoes/ato-processual']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
